var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatestUpdateDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 6.86328H3.25V8.36328H4.75V6.86328ZM7.75 6.86328H6.25V8.36328H7.75V6.86328ZM10.75 6.86328H9.25V8.36328H10.75V6.86328ZM12.25 1.61328H11.5V0.113281H10V1.61328H4V0.113281H2.5V1.61328H1.75C0.9175 1.61328 0.25 2.28828 0.25 3.11328V13.6133C0.25 14.0111 0.408035 14.3926 0.68934 14.6739C0.970644 14.9552 1.35218 15.1133 1.75 15.1133H12.25C12.6478 15.1133 13.0294 14.9552 13.3107 14.6739C13.592 14.3926 13.75 14.0111 13.75 13.6133V3.11328C13.75 2.71546 13.592 2.33393 13.3107 2.05262C13.0294 1.77132 12.6478 1.61328 12.25 1.61328ZM12.25 13.6133H1.75V5.36328H12.25V13.6133Z",
    fill: "#505887"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestUpdateDateIcon);
export default __webpack_public_path__ + "static/media/latest-update-date-icon.54f50813ffb01c81fefccd39947611a6.svg";
export { ForwardRef as ReactComponent };